import SendMessageModal from 'components/modals/send_message_modal';
import 'components/button_follow_user';
import 'components/user/avatar';
import 'components/avatar_upload';

import './index.scss';
import { EventManager } from 'utils/event_manager';
import { handleApiError } from 'utils/api_error_handler';

class ProfileBox {
  constructor() {
    this.$profileBox = $('.js-profile-box');
    this.$userBlockButton = $('.js-user-block-button', this.$profileBox);
    this.$userMessageButton = $('.js-user-message-button', this.$profileBox);
    this.$profileForm = $('.js-profile-form', this.$profileBox);
    this.$cancelButton = $('.js-cancel-profile-form', this.$profileBox);
    this.$submitButton = $('button[type="submit"]', this.$profileBox);
    this.bindAll();
  }

  _renderSocialList(data) {
    return Object.keys(data['user_profile'])
      .filter(item => item !== 'about_me')
      .map(key => {
        if (data['user_profile'][key].length <= 0) {
          return '';
        }

        const styles = {
          facebook: 'facebook-f',
          twitter: 'twitter',
          website: 'globe',
          linked_in: 'linkedin-in'
        };

        return `
        <li>
          <a
            class="q-icon q-icon-${styles[key]}"
            target="_blank" href="${data['user_profile'][key]}"
          ></a>
        </li>
        `;
      })
      .filter(item => item.length > 0)
      .join('');
  }

  _bindProfileForm() {
    EventManager.subscribe('avatar_upload.start', () => {
      this.$submitButton.attr('disabled', true);
    });

    EventManager.subscribe('avatar_upload.ended', () => {
      this.$submitButton.attr('disabled', false);
    });

    this.$cancelButton.off('click');
    this.$cancelButton.on('click', () => {
      EventManager.publish('profile_box_form.canceled');
    });

    this.$profileForm.submit(event => {
      event.preventDefault();

      const errorList = this.$profileForm
        .children()
        .toArray()
        .filter(el => $(el).hasClass('has-error'));

      if (errorList.length > 0) {
        toastr.error('Oops, parace que tem algo de errado com seus dados!');
        return;
      }

      const data = this.$profileForm.serializeObject();

      // eslint-disable-next-line no-prototype-builtins
      if (!data.hasOwnProperty('user_profile')) {
        // eslint-disable-next-line no-console
        console.warn('The form data does not contain profile info of the user');
        return;
      }

      const body = { data: { user_profile: data['user_profile'] } };

      if (!body.data['user_profile']['user_attributes']['avatar_id']) {
        body.data['user_profile']['user_attributes']['avatar_id'] = '';
      }

      const socialProfileContent = ['about_me', 'twitter', 'facebook', 'linked_in', 'website'];

      socialProfileContent.forEach(content => {
        if (!body.data['user_profile'][content]) {
          body.data['user_profile'][content] = '';
        }
      });

      Thor.UserProfile.update({}, body)
        .then(() => {
          const $socialList = $('.js-social', this.$profileBox);
          $('li', $socialList).remove();
          $socialList.html(this._renderSocialList(data));

          $('.js-about-me', this.$profileBox).text(data['user_profile']['about_me']);

          $('.js-is-editable-profile', this.$profileBox).prop('checked', false);

          toastr.success('Seu perfil foi atualizado com sucesso!');
          Turbolinks.visit(window.location.toString());
        })
        .catch(err => {
          handleApiError('Oops, aconteceu algum erro!', err);
        });
    });
  }

  _bindUserBlockButton() {
    this.$userBlockButton.off('click');
    this.$userBlockButton.on('click', event => {
      event.preventDefault();
      const $el = $(event.currentTarget);

      if ($el.data().isBlocked) {
        Thor.UserBlacklist.delete({ id: $el.data().userId })
          .then(() => {
            $el.data('isBlocked', false);
            $el.attr('data-is-blocked', false);
            this.$userBlockButton.html(['<i class="q-icon q-icon-ban"></i>', '<span>Bloquear</span>'].join(''));
            toastr.success('Usuário desbloqueado com sucesso!');
          })
          .catch(err => {
            handleApiError('Aconteceu algo de errado ao tentar desbloquear o usuário!', err);
          });
      } else {
        Thor.UserBlacklist.create({}, { data: { user_blacklist: { blocked_id: $el.data().userId } } })
          .then(() => {
            $el.data('isBlocked', true);
            $el.attr('data-is-blocked', true);
            this.$userBlockButton.html(['<i class="q-icon q-icon-ban"></i>', '<span>Desbloquear</span>'].join(''));
            toastr.success('Usuário bloqueado com sucesso!');
          })
          .catch(err => {
            handleApiError('Aconteceu algo de errado ao tentar bloquear o usuário!', err);
          });
      }
    });
  }

  _bindUserMessageButton() {
    this.$userMessageButton.off('click.profileBoxMessage');
    this.$userMessageButton.on('click.profileBoxMessage', event => {
      const data = $(event.currentTarget).data();
      SendMessageModal.open(data.recipientName, data.recipientId);
    });
  }

  bindAll() {
    this._bindProfileForm();
    this._bindUserBlockButton();
    this._bindUserMessageButton();
  }
}

(function () {
  'use strict';
  new ProfileBox();
})();
